"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({}, props, {
    width: "24px",
    height: "20px",
    viewBox: "780 181 24 20"
  }), /*#__PURE__*/_react["default"].createElement("g", {
    id: "preview",
    stroke: "none",
    strokeWidth: "1",
    fillRule: "evenodd",
    transform: "translate(780.000000, 181.000000)"
  }, /*#__PURE__*/_react["default"].createElement("path", {
    d: "M0,2.00585866 C0,0.898053512 0.897026226,0 2.00494659,0 L21.9950534,0 C23.1023548,0 24,0.897060126 24,2.00585866 L24,11.9941413 C24,13.1019465 23.1029738,14 21.9950534,14 L2.00494659,14 C0.897645164,14 0,13.1029399 0,11.9941413 L0,2.00585866 Z M9,10 L9,4 L15,7 L9,10 Z",
    id: "Combined-Shape"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M8,15 L11,15 L8,20 L5,20 L8,15 Z M16,15 L13,15 L16,20 L19,20 L16,15 Z",
    id: "Rectangle-1169"
  })));
};

exports["default"] = _default;